import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ServicesService } from 'src/services/services.service';

@Component({
  selector: 'app-create-event-stall',
  templateUrl: './create-event-stall.component.html',
  styleUrls: ['./create-event-stall.component.scss']
})
export class CreateEventStallComponent {
  eventForm!: FormGroup;
  stallForm!: FormGroup;
  ownerForm!: FormGroup;

  selectedImage: File | null = null;
  imagePreview: string | null = null;

  constructor(private fb: FormBuilder,
    private service: ServicesService
  ) { }

  ngOnInit(): void {
    this.eventForm = this.fb.group({
      event_name: ['', Validators.required],
      address: ['', Validators.required],
      from_date: ['', Validators.required],
      to_date: ['', Validators.required],
    });

    this.stallForm = this.fb.group({
      stall_number: ['', Validators.required],
    });

    this.ownerForm = this.fb.group({
      image_name: [''],
      owner_name: ['', Validators.required],
      owner_number: ['', [Validators.required, Validators.pattern(/^[0-9]{10}$/)]],
      email: ['', [Validators.required, Validators.email]],
      company_name: ['', Validators.required],
      address: ['', Validators.required],
      website: [''],
      youtube: [''],
      instagram: [''],
      notes: [''],
    });
  }

  onImageChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files[0]) {
      this.selectedImage = input.files[0];
      this.ownerForm.patchValue({ image_name: this.selectedImage.name });

      const reader = new FileReader();
      reader.onload = () => {
        this.imagePreview = reader.result as string;
      };
      reader.readAsDataURL(this.selectedImage);
    }
  }

  onSubmit(): void {
    if (this.eventForm.invalid || this.stallForm.invalid || this.ownerForm.invalid) {
      this.eventForm.markAllAsTouched();
      this.stallForm.markAllAsTouched();
      this.ownerForm.markAllAsTouched();
      return;
    }

    // Format date properly (YYYY-MM-DD)
    const fromDate = this.formatDate(this.eventForm.value.from_date);
    const toDate = this.formatDate(this.eventForm.value.to_date);

    // Final API Payload (FLAT STRUCTURE)
    const finalPayload = {
      event_name: this.eventForm.value.event_name,
      event_address: this.eventForm.value.address,
      from_date: fromDate,
      to_date: toDate,

      stall_num: this.stallForm.value.stall_number,

      image_name: this.ownerForm.value.image_name,
      owner_name: this.ownerForm.value.owner_name,
      owner_number: this.ownerForm.value.owner_number,
      company_name: this.ownerForm.value.company_name,
      email: this.ownerForm.value.email,
      address: this.ownerForm.value.address,
      website: this.ownerForm.value.website,
      youtube: this.ownerForm.value.youtube,
      instagram: this.ownerForm.value.instagram,
      notes: this.ownerForm.value.notes,

      created_by: sessionStorage.getItem('User_ID')
    };

    // 🚀 If image selected → upload first
    if (this.selectedImage) {
      this.uploadImageAndSubmit(finalPayload);
    } else {
      this.submitEvent(finalPayload);
    }
  }

  uploadImageAndSubmit(payload: any) {

    const reader = new FileReader();

    reader.onload = () => {
      const base64Image = reader.result;

      this.service.uploadimage(base64Image, '0/stall')
        .subscribe((res: any) => {

          payload.image_name = res.image_name; // image returned from backend
          this.submitEvent(payload);

        });
    };

    reader.readAsDataURL(this.selectedImage as File);
  }

  submitEvent(payload: any) {
    this.service.add_so_events(payload)
      .subscribe((res: any) => {

        console.log('API Response:', res);

        if (res.flag === true) {
          alert('Stall Created Successfully');
          this.onReset();
        } else {
          alert('Something went wrong');
        }

      });
  }

  formatDate(date: any): string {
    const d = new Date(date);
    const month = ('0' + (d.getMonth() + 1)).slice(-2);
    const day = ('0' + d.getDate()).slice(-2);
    return `${d.getFullYear()}-${month}-${day}`;
  }

  onReset(): void {
    this.eventForm.reset();
    this.stallForm.reset();
    this.ownerForm.reset();
    this.selectedImage = null;
    this.imagePreview = null;
  }
}
